export const SAVE = 'stepSupportingDocuments.SAVE';
export const VALUE_CHANGED = 'stepSupportingDocuments.VALUE_CHANGED';
export const LOAD = 'stepSupportingDocuments.VALUE_LOAD';
export const NEXT = 'stepSupportingDocuments.NEXT';
export const UPLOAD_FILE = 'stepSupportingDocuments.UPLOAD_FILE';
export const UPLOAD_FILE_SUCCESS = 'stepSupportingDocuments.UPLOAD_FILE_SUCCESS';
export const VALIDATE_FILE = 'stepSupportingDocuments.VALIDATE_FILE';
export const UPLOAD_PERCENTAGE = 'stepSupportingDocuments.UPLOAD_PERCENTAGE';
export const UPLOAD_PROGRESS_VISIBILITY = 'stepSupportingDocuments.UPLOAD_PROGRESS_VISIBILITY';
export const REMOVE_FILE = 'stepSupportingDocuments.REMOVE_FILE';
export const REMOVE_FILE_SUCCESS = 'stepSupportingDocuments.REMOVE_FILE_SUCCESS';
export const LOAD_CLAIM_ATTACHMENTS = 'stepSupportingDocuments.LOAD_CLAIM_ATTACHMENTS';
export const LOAD_CLAIM_ATTACHMENTS_SUCCESS = 'stepSupportingDocuments.LOAD_CLAIM_ATTACHMENTS_SUCCESS';
export const RESET = 'stepSupportingDocuments.RESET';
export const UPLOAD_FILE_DOC = 'stepSupportingDocuments.UPLOAD_FILE_DOC';



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/constants.js